export default {
  listClient(params) {
    return Request.get('api/job/client', params);
  },
  showJob(id) {
    return Request.get(`api/job/client/${id}`);
  },
  listClientType(params) {
    return Request.get('api/job/client_type', params);
  },
  listIntern(params) {
    return Request.get('api/job/client_top', params);
  },
};
